import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SettingsChatbotsView } from './settingsChatbots.view';
import { MimWrapper } from './views/mimWrapper';
import { SettingsChatbotsThirdPartyView } from './views/thirdParty';

const SettingsChatbotsRoutes = (): JSX.Element | null => {
  const flags = useFeatureFlag(['ada-chat-channel', 'mim-chatbot']);
  if (!flags.adaChatChannel && !flags.mimChatbot) {
    return null;
  }

  return (
    <Routes>
      <Route path="*" element={<SettingsChatbotsView />}>
        {flags.mimChatbot && <Route path="mim" element={<MimWrapper />} />}
        {flags.adaChatChannel && (
          <Route
            path="third-party"
            element={<SettingsChatbotsThirdPartyView />}
          />
        )}

        <Route
          index
          element={<Navigate to={flags.mimChatbot ? 'mim' : 'third-party'} />}
        />
      </Route>
    </Routes>
  );
};

export const settingsChatbotsRoutes = (
  <Route path="chatbots/*" element={<SettingsChatbotsRoutes />} />
);
